import React, { useState } from "react";
import { Box, Collapse, IconButton, Step, StepContent, StepLabel, StepProps } from "@material-ui/core";
import { ReadOnlyField } from "components/SchemaProvider";
import { CustomChip, Ellipsis } from "components";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { ExpandableHistorySelector } from "pages/MaterialSpecs/components/InfoPanel/History/ExpandableHistorySelector/ExpandableHistorySelector";
import { AuditStatusRes, Status, UserRes } from "api";

interface HistoryItem {
    audits: AuditStatusRes[];
    source: string | AuditStatusRes;
    historyId: number;
    user: UserRes;
    status: Status;
    sourceType?: string;
    endTime: string;
}

export const HistoryItem = ({
    historyId,
    audits,
    status,
    source,
    endTime,
    user,
    active,
    disabled,
    ...props
}: HistoryItem & StepProps) => {
    const [isExpanded, setExpanded] = useState(false);

    return (
        <Step disabled={false} active {...props}>
            <StepLabel icon=" ">
                <Box flex={2} display="flex" bgcolor="white">
                    <ReadOnlyField label={endTime} paddingX={0.5} paddingY={0.5} />
                    <ReadOnlyField paddingX={0.5} paddingY={0.5}>
                        <Box width="60px" fontWeight="fontWeightBold">
                            <Ellipsis>{user.rol || "System"}</Ellipsis>
                        </Box>
                    </ReadOnlyField>
                    <ReadOnlyField paddingX={0.5} paddingY={0.5}>
                        <Ellipsis width="170px">{typeof source === "string" ? source : source.name}</Ellipsis>
                    </ReadOnlyField>
                    <Box
                        position="relative"
                        flex={1}
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="center"
                        mr={4}>
                        <CustomChip bgColor={status.color} label={status.text} minWidth={180} />
                        {audits.length !== 0 && (
                            <Box position="absolute" top="1px" right="-29px">
                                <IconButton size="small" onClick={() => setExpanded((expanded) => !expanded)}>
                                    {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                            </Box>
                        )}
                    </Box>
                </Box>
            </StepLabel>
            <StepContent>
                <Collapse in={isExpanded} timeout={300} mountOnEnter style={{ backgroundColor: "white" }}>
                    <Box p={1}>
                        <ExpandableHistorySelector
                            id={historyId}
                            audits={audits}
                            status={status}
                            source={source}
                            endTime={endTime}
                            user={user}
                        />
                    </Box>
                </Collapse>
            </StepContent>
        </Step>
    );
};
